import Shiitake from 'shiitake';
import * as React from 'react';
import * as styles from '../../css/PreziCard.less';
import LazyLoad from 'react-lazyload';

import { PreziData } from '../App';
import { WindowSizeBreakpoints, DesktopLazyLoadOffset, MobileLazyLoadOffset } from '../../components/Consts';

interface PreziCardProps {
    prezi: PreziData;
}

const ReuseContainer: React.SFC<{}> = () => {
    return (
        <div className={ styles.reuseContainer }>
            <i className={ 'icon-reuse ' + styles.reuseIcon } />
        </div>
    );
};

export const PreziCard: React.SFC<PreziCardProps> = (props: PreziCardProps) => {
    const urlWithClickTracking = `${props.prezi.landing_url}?click_source=logged_element&element_type=prezi_card&element_text=${ props.prezi.oid }`;
    const reuseContainer: React.ReactNode | null = props.prezi.can_reuse ? <ReuseContainer /> : null;
    const lazyLoadOffset: number = window.innerWidth > WindowSizeBreakpoints.SMALL ? DesktopLazyLoadOffset : MobileLazyLoadOffset;

    return (
        <div className={ 'col-xs-12 col-sm-4' }>
            <a className="no-underline" href={ urlWithClickTracking }>
                <div className={ styles.preziCard + ' shadow-sm' }>
                    <div className={ styles.preziThumbnail }>
                        { reuseContainer }
                        <LazyLoad height="200px" once={ true } offset={ lazyLoadOffset }>
                            <img className={ `img-responsive ${styles.preziImage}` } src={ props.prezi.thumbnail_url } />
                        </LazyLoad>
                    </div>
                    <div className={ styles.thumbnailInfo }>
                        <Shiitake lines={ 1 } className="h4 btm-0" tagName="p">
                            { props.prezi.title }
                        </Shiitake>
                        <Shiitake lines={ 1 } className="small btm-6 text-gray-3 bold" tagName="p">
                            { props.prezi.owner_name }
                        </Shiitake>
                        <div className={ 'h4 btm-6 ' + styles.textTruncate }>{ props.prezi.name }</div>
                        <Shiitake lines={ 2 } className="small text-gray-3 semibold btm-0" tagName="p">
                            { props.prezi.description }
                        </Shiitake>
                    </div>
                </div>
            </a>
        </div>
    );
};



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/PreziCard/PreziCard.tsx